import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FormGroupComponent } from './form-group/form-group.component';
import { TextboxComponent } from './attribute-components/textbox/textbox.component';
import { IntegerComponent } from './attribute-components/integer/integer.component';
import { DecimalComponent } from './attribute-components/decimal/decimal.component';
import { CheckboxComponent } from './attribute-components/checkbox/checkbox.component';
import { DateComponent } from './attribute-components/date/date.component';
import { TimeComponent } from './attribute-components/time/time.component';
import { DateTimeComponent } from './attribute-components/date-time/date-time.component';
import { SelectComponent } from './attribute-components/select/select.component';
import { MultiSelectComponent } from './attribute-components/multi-select/multi-select.component';
import { AttributeDirective } from './directives/attribute.directive';
import { MouseInteractionDirective } from './directives/mouse-interaction.directive';
import { AttributeControlService } from './attribute-control-service';
import { DatepickerUtilsService } from 'src/app/services/ui/datepicker-utils.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
	declarations: [
		FormGroupComponent,
		TextboxComponent,
		IntegerComponent,
		DecimalComponent,
		CheckboxComponent,
		DateComponent,
		TimeComponent,
		DateTimeComponent,
		SelectComponent,
		MultiSelectComponent,
		AttributeDirective,
		MouseInteractionDirective,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatOptionModule,
		MatIconModule,
		MatButtonModule,
		MatDatepickerModule,
		NgxMaterialTimepickerModule,
		NgxMatDatetimePickerModule,
		NgxMatTimepickerModule,
		NgxMatNativeDateModule,
	],
	providers: [
		AttributeControlService,
		DatepickerUtilsService
	],
	exports: [
		FormGroupComponent
	]
})
export class DynamicControlsModule { }
